export abstract class BaseSearchModel {
      limit: any;
}



// WEBPACK FOOTER //
// ./src/app/core/base/base-search.model.ts